export const ALERT_TYPE_MEDICAL_HELP = 'medical-help'
export const ALERT_TYPE_TECHNICAL_HELP = 'technical-help'
export const ALERT_TYPE_OK = 'ok'
export const ALERT_TYPE_LOW_BATTERY = 'low-battery'
export const ALERT_TYPE_OFF_TRACK = 'off-track'
